export class FeatureSwitch {
  static startingTab = 0;
}
